export class CachedFile {
    internalReferenceId?: string;
    messageId?: string;
    localFile: File;

    constructor(localFile: File, internalReferenceId?: string, messageId?: string) {
        this.localFile = localFile;
        this.internalReferenceId = internalReferenceId;
        this.messageId = messageId;
    }

    getFileUrl(): string {
        return URL.createObjectURL(this.localFile);
    }
}
